import { Maximize, Pause, Play, Volume2, VolumeOff } from "lucide-react";
import { useEffect, useRef, useState } from "react";

import appStore from "store/appStore";
import { AppLog } from "services";
import "./ProfilePostVideoPlayer.css";
import "./ProfileVideoPlayer.css";
import { StatusMsg } from "utils";
import { FaCog, FaExpand, FaPause, FaPlay, FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import { Service } from "utils/services";

export default function VideoPostContent({ postAttchment, videoRefCallback }: { postAttchment: any; videoRefCallback: (el: HTMLVideoElement | null) => void }) {
  const [aspectRatio, setAspectRatio] = useState(16 / 9);
  const [isLandscape, setIsLandscape] = useState(true);

  const videoContainerRef = useRef<HTMLDivElement>(null);
  let isLargeScreen = window.innerWidth >= 1024;

  // new code
  const internalVideoRef = useRef<HTMLVideoElement>(null);
  const { isMuted, volume, toggleMute, setGlobalVolume } = appStore();
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [controlsVisible, setControlsVisible] = useState(false);
  const [hoverX, setHoverX] = useState<number | null>(null);
  const sliderRef = useRef<HTMLDivElement>(null);
  const [hoverTime, setHoverTime] = useState<number | null>(null);
  useEffect(() => {
    const width = Service.toDouble(postAttchment?.post_attachments[0]?.attachment_media_width);
    const height = Service.toDouble(postAttchment?.post_attachments[0]?.attachment_media_height);

    setAspectRatio(width / height);
    setIsLandscape(width >= height);
    const video = internalVideoRef.current;

    if (video) {
      videoRefCallback(video);
      video.muted = isMuted;
      video.volume = volume;

      const handlePlay = () => setIsPlaying(true);
      const handlePause = () => setIsPlaying(false);

      const handleFullscreenChange = () => {
        setIsFullscreen(!!document.fullscreenElement);
      };

      video.addEventListener("play", handlePlay);
      video.addEventListener("pause", handlePause);

      document.addEventListener("fullscreenchange", handleFullscreenChange);

      return () => {
        video.removeEventListener("play", handlePlay);
        video.removeEventListener("pause", handlePause);
        document.removeEventListener("fullscreenchange", handleFullscreenChange);
      };
    }
  }, [videoRefCallback, isMuted, volume, postAttchment?.post_attachments]);

  const handleTimeUpdate = () => {
    const video = internalVideoRef.current;
    if (video) setCurrentTime(video.currentTime);
  };
  const togglePlayPause = () => {
    try {
      const video = internalVideoRef.current;
      if (video) {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      }
    } catch (error) {
      AppLog.show({
        message: `[togglePlayPause]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const handleSpeedChange = () => {
    const newRate = playbackRate >= 2 ? 1 : playbackRate + 0.5;
    setPlaybackRate(newRate);
    if (internalVideoRef.current) {
      internalVideoRef.current.playbackRate = newRate;
    }
  };
  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  // end code

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      videoContainerRef.current?.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);
  const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value);
    setGlobalVolume(newVolume);
  };
  const width = Service.toDouble(postAttchment?.post_attachments[0]?.attachment_media_width);
  const height = Service.toDouble(postAttchment?.post_attachments[0]?.attachment_media_height);
  const ratio = height === 0 ? 1 : width / height;
  return (
    <>
      {/* <div className="absolute max-sm:top-3 max-sm:right-3 top-5 right-8 flex space-x-2  z-50 select-none">
        <Popover>
          <PopoverTrigger asChild>
            <Ellipsis
              // onClick={handleZoomOut}
              className={`w-8 h-8 max-sm:w-6 cursor-pointer max-sm:h-6 bg-gray-600 text-white opacity-70 rounded-full p-1 transition-opacity duration-200
               `}
            />
          </PopoverTrigger>
          <PopoverContent className="w-92"></PopoverContent>
        </Popover>
      </div> */}
      <div
        ref={videoContainerRef}
        className={` flex items-center relative w-full group lg:h-screen h-[60vh] ${isFullscreen ? "fixed inset-0 w-screen h-screen z-[9999] bg-black" : ""}`}
      >
        <div
          style={{ aspectRatio: `${aspectRatio}` }}
          className={`${isLargeScreen || isLandscape ? "" : "video-container"}  relative ${
            isFullscreen
              ? "flex w-full h-screen items-center justify-center"
              : isLandscape
              ? "flex items-center justify-center aspect-w-16 aspect-h-9"
              : "flex items-center justify-center object-cover   lg:h-screen h-[60vh]"
          }`}
          onMouseEnter={() => setControlsVisible(true)}
          onMouseLeave={() => {
            setTimeout(() => {
              if (isPlaying) setControlsVisible(false);
            }, 300);
          }}
        >
          <video
            ref={internalVideoRef}
            src={postAttchment?.post_attachments[0]?.attachment_media_image_file_src}
            loop
            autoPlay
            muted={isMuted}
            onTimeUpdate={handleTimeUpdate}
            onLoadedMetadata={() => setDuration(internalVideoRef.current?.duration || 0)}
            onClick={togglePlayPause}
            playsInline
            style={{
              pointerEvents: "auto",
            }}
            className={`relative z-10  w-full h-full ${isFullscreen ? " object-contain" : ` ${ratio >= 0 && ratio < 0.74 ? " object-cover " : " object-contain "} `}`}
          />

          {/* Play/Pause Icon */}

          {!isPlaying && (
            <div className="absolute inset-0 flex items-center justify-center cursor-pointer" onClick={togglePlayPause}>
              <div className="bg-blue-500 bg-opacity-80 rounded-full p-3">
                <FaPlay className="text-white text-2xl" />
              </div>
            </div>
          )}
          {/* Down Controll  When full screen*/}
          {isFullscreen && (controlsVisible || !isPlaying) ? (
            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-30 text-white px-3 py-2 transition-opacity duration-300 opacity-100 z-10">
              <div className="flex items-center justify-between">
                <div className="flex items-center flex-1">
                  <button onClick={togglePlayPause} className="text-xl mr-4 z-20">
                    {isPlaying ? <FaPause /> : <FaPlay />}
                  </button>
                  <input
                    type="range"
                    min="0"
                    max={duration.toString()}
                    step="0.1"
                    value={currentTime}
                    onChange={(e) => {
                      const video = internalVideoRef.current;
                      if (video) {
                        video.currentTime = parseFloat(e.target.value);
                        setCurrentTime(video.currentTime);
                      }
                    }}
                    className="flex-1 seek-slider h-1 z-20"
                    style={{
                      background: `linear-gradient(to right, #007bff ${(currentTime / duration) * 100}%, #ccc ${(currentTime / duration) * 100}%)`,
                    }}
                  />
                </div>
                <span className="mx-4 text-sm">{`${formatTime(currentTime)} / ${formatTime(duration)}`}</span>
                <div className="flex items-center">
                  <button onClick={toggleMute} className="text-xl mr-2 z-20">
                    {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
                  </button>
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={isMuted ? 0 : volume}
                    onChange={handleVolumeChange}
                    className="w-16 volume-slider h-1 z-20"
                    style={{
                      background: isMuted
                        ? `#ccc` // Gray when muted
                        : `linear-gradient(to right, #007bff ${volume * 100}%, #ccc ${volume * 100}%)`,
                    }}
                  />
                </div>
                <button onClick={handleSpeedChange} className="flex items-center mx-4 text-xl space-x-1 z-20">
                  <FaCog />
                  <span className="text-sm">{playbackRate}x</span>
                </button>
                <button onClick={toggleFullscreen} className="text-xl z-20">
                  <FaExpand />
                </button>
              </div>
            </div>
          ) : null}

          {/* Up Controll  */}
          {!isFullscreen && (controlsVisible || !isPlaying) && (
            <div className="absolute top-0 left-0 right-0 text-white px-3 py-2 transition-opacity duration-300 opacity-100 z-10 ">
              <div className="flex flex-row justify-between">
                <div className="flex items-center justify-start space-x-3">
                  {/* Play / Pause */}
                  <button onClick={togglePlayPause} className="bg-black bg-opacity-30 rounded-full p-3">
                    {isPlaying ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
                  </button>

                  <div className="group/volume relative flex items-center bg-black bg-opacity-30 rounded-full h-10 transition-all duration-300 w-10 hover:w-64 overflow-hidden px-2 ">
                    {/* Volume Icon */}
                    <button onClick={toggleMute} className="flex-shrink-0 ">
                      {isMuted ? <VolumeOff className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
                    </button>

                    {/* Slider */}
                    <input
                      type="range"
                      min="0"
                      max="1"
                      step="0.01"
                      value={isMuted ? 0 : volume}
                      onChange={handleVolumeChange}
                      className="ml-3 w-full h-1 appearance-none bg-transparent focus:outline-none opacity-0 group-hover/volume:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-opacity duration-300"
                      style={{
                        background: isMuted ? "#ccc" : `linear-gradient(to right, #fff ${volume * 100}%, #555 ${volume * 100}%)`,
                      }}
                    />
                  </div>
                </div>
                <button onClick={toggleFullscreen} className="bg-black bg-opacity-30 rounded-full p-3">
                  <Maximize className="w-4 h-4" />
                </button>
              </div>
            </div>
          )}

          {/* Down Controll  */}
          {!isFullscreen && (controlsVisible || !isPlaying) ? (
            <div className="absolute bottom-0 left-0 right-0 z-20 text-white transition-opacity duration-300 opacity-100 p-0 custom-slider-wrapper">
              <div className="relative w-full">
                {/* Tooltip */}
                {hoverTime !== null && hoverX !== null && (
                  <div
                    className="absolute bottom-6 text-xs px-2 py-1 rounded bg-black bg-opacity-70 pointer-events-none whitespace-nowrap"
                    style={{ left: hoverX, transform: "translateX(-50%)" }}
                  >
                    {hoverTime.toFixed(1)}s
                  </div>
                )}

                {/* Slider */}
                <div
                  ref={sliderRef}
                  className="flex items-center flex-1"
                  onMouseMove={(e) => {
                    const rect = sliderRef.current?.getBoundingClientRect();
                    if (!rect) return;
                    const x = e.clientX - rect.left;
                    const percent = x / rect.width;
                    const time = Math.min(duration, Math.max(0, duration * percent));
                    setHoverX(x);
                    setHoverTime(time);
                  }}
                  onMouseLeave={() => {
                    setHoverX(null);
                    setHoverTime(null);
                  }}
                >
                  <input
                    type="range"
                    min="0"
                    max={duration.toString()}
                    step="0.1"
                    value={currentTime}
                    onChange={(e) => {
                      const video = internalVideoRef.current;
                      if (video) {
                        video.currentTime = parseFloat(e.target.value);
                        setCurrentTime(video.currentTime);
                      }
                    }}
                    className="seek-slider w-full appearance-none"
                    style={{
                      background: `linear-gradient(to right, #007bff ${(currentTime / duration) * 100}%, #ccc ${(currentTime / duration) * 100}%)`,
                    }}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}
